'use client';

import useDevice from '@/hooks/useDevice';
import "@/styles/sections/sections.scss";
import { useLanguage } from '@/context/LanguageContext';

const SocialProofSection = () => {
    const { t } = useLanguage();

    const brands_1 = [
        { src: "/images/brands/lf_logo.png", alt: "brand1" },
        { src: "/images/brands/allegri_logo.png", alt: "brand1" },
        { src: "/images/brands/hazzys_logo.png", alt: "brand1" },
        { src: "/images/brands/daks_logo.png", alt: "brand1" },
        { src: "/images/brands/doubleflag_logo.png", alt: "brand1" },
    ];
    const brands_2 = [
        { src: "/images/brands/sjsj_logo.png", alt: "brand1" },
        { src: "/images/brands/system_logo.png", alt: "brand1" },
        { src: "/images/brands/o2nd_logo.png", alt: "brand1" },
        { src: "/images/brands/Shinyoung_logo.png", alt: "brand1" },
        { src: "/images/brands/solb_logo.png", alt: "brand1" },
    ];
    const brands_3 = [
        { src: "/images/brands/tbh global.png", alt: "brand1" },
        { src: "/images/brands/MIND BRIDGE_logo.png", alt: "brand1" },
        { src: "/images/brands/pond_logo.png", alt: "brand1" },
        { src: "/images/brands/puma_logo.png", alt: "brand1" },
        { src: "/images/brands/true_logo.png", alt: "brand1" },
    ];
    const brands_4 = [
        { src: "/images/brands/blueforce_logo.png", alt: "brand1" },
        { src: "/images/brands/dhoic_logo.png", alt: "brand1" },
        { src: "/images/brands/avirex_logo.png", alt: "brand1" },
        { src: "/images/brands/hdm_logo.png", alt: "brand1" },
        { src: "/images/brands/doyouknowmc_logo.png", alt: "brand1" },
    ];
    const brands_5 = [
        { src: "/images/brands/hypereet_logo.png", alt: "brand1" },
        { src: "/images/brands/cgital_logo.png", alt: "brand1" },
        { src: "/images/brands/chicnom_logo.png", alt: "brand1" },
        { src: "/images/brands/kingsm_logo.png", alt: "brand1" },
        { src: "/images/brands/pixen_logo.png", alt: "brand1" },
    ];

    return (
        <div className="socialproof-section">
            <p className="title" dangerouslySetInnerHTML={{ __html: t.socialproof.title }} />
            <div className="brands-container">
                <div className="brands-slide">
                    {/* 4세트 복제로 매끄러운 무한 슬라이드 */}
                    {brands_1.map((brand, index) => (
                        <img key={`set1-${index}`} src={brand.src} alt={brand.alt} />
                    ))}
                    {brands_1.map((brand, index) => (
                        <img key={`set2-${index}`} src={brand.src} alt={brand.alt} />
                    ))}
                    {brands_1.map((brand, index) => (
                        <img key={`set3-${index}`} src={brand.src} alt={brand.alt} />
                    ))}
                    {brands_1.map((brand, index) => (
                        <img key={`set4-${index}`} src={brand.src} alt={brand.alt} />
                    ))}
                </div>
                <div className="brands-slide-reverse">
                    {/* 4세트 복제로 매끄러운 무한 슬라이드 */}
                    {brands_2.map((brand, index) => (
                        <img key={`set1-${index}`} src={brand.src} alt={brand.alt} />
                    ))}
                    {brands_2.map((brand, index) => (
                        <img key={`set2-${index}`} src={brand.src} alt={brand.alt} />
                    ))}
                    {brands_2.map((brand, index) => (
                        <img key={`set3-${index}`} src={brand.src} alt={brand.alt} />
                    ))}
                    {brands_2.map((brand, index) => (
                        <img key={`set4-${index}`} src={brand.src} alt={brand.alt} />
                    ))}
                </div>
                <div className="brands-slide">
                    {/* 4세트 복제로 매끄러운 무한 슬라이드 */}
                    {brands_3.map((brand, index) => (
                        <img key={`set1-${index}`} src={brand.src} alt={brand.alt} />
                    ))}
                    {brands_3.map((brand, index) => (
                        <img key={`set2-${index}`} src={brand.src} alt={brand.alt} />
                    ))}
                    {brands_3.map((brand, index) => (
                        <img key={`set3-${index}`} src={brand.src} alt={brand.alt} />
                    ))}
                    {brands_3.map((brand, index) => (
                        <img key={`set4-${index}`} src={brand.src} alt={brand.alt} />
                    ))}
                </div>
                <div className="brands-slide-reverse">
                    {/* 4세트 복제로 매끄러운 무한 슬라이드 */}
                    {brands_4.map((brand, index) => (
                        <img key={`set1-${index}`} src={brand.src} alt={brand.alt} />
                    ))}
                    {brands_4.map((brand, index) => (
                        <img key={`set2-${index}`} src={brand.src} alt={brand.alt} />
                    ))}
                    {brands_4.map((brand, index) => (
                        <img key={`set3-${index}`} src={brand.src} alt={brand.alt} />
                    ))}
                    {brands_4.map((brand, index) => (
                        <img key={`set4-${index}`} src={brand.src} alt={brand.alt} />
                    ))}
                </div>
                <div className="brands-slide">
                    {/* 4세트 복제로 매끄러운 무한 슬라이드 */}
                    {brands_5.map((brand, index) => (
                        <img key={`set1-${index}`} src={brand.src} alt={brand.alt} />
                    ))}
                    {brands_5.map((brand, index) => (
                        <img key={`set2-${index}`} src={brand.src} alt={brand.alt} />
                    ))}
                    {brands_5.map((brand, index) => (
                        <img key={`set3-${index}`} src={brand.src} alt={brand.alt} />
                    ))}
                    {brands_5.map((brand, index) => (
                        <img key={`set4-${index}`} src={brand.src} alt={brand.alt} />
                    ))}
                </div>
            </div>

        </div>
    );
};

export default SocialProofSection;